function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M30.999 61.998c-17.121 0-31-13.878-31-31 0-17.121 13.879-31 31-31 17.12 0 30.999 13.879 30.999 31 0 17.122-13.879 31-30.999 31zm0-60.121c-16.083 0-29.122 13.038-29.122 29.121S14.916 60.12 30.999 60.12c16.082 0 29.121-13.039 29.121-29.122S47.081 1.877 30.999 1.877zM42 30h-6a1 1 0 0 1 0-2h3.372a623.93 623.93 0 0 1-2.716-2.657A7.973 7.973 0 0 0 31 23a7.965 7.965 0 0 0-5.657 2.343A7.965 7.965 0 0 0 23 31a7.973 7.973 0 0 0 2.343 5.656A7.965 7.965 0 0 0 31 39a7.973 7.973 0 0 0 5.656-2.344 7.946 7.946 0 0 0 1.888-2.989 1 1 0 1 1 1.886.666 9.953 9.953 0 0 1-2.359 3.738A9.965 9.965 0 0 1 31 41c-.64 0-1.283-.062-1.91-.183a9.95 9.95 0 0 1-5.161-2.746 9.95 9.95 0 0 1-2.746-5.162 10.016 10.016 0 0 1 0-3.818 9.935 9.935 0 0 1 2.746-5.162 9.92 9.92 0 0 1 5.161-2.746 10.026 10.026 0 0 1 5.672.549 9.934 9.934 0 0 1 3.309 2.197c.299.298 1.468 1.441 2.929 2.865V23a1 1 0 1 1 2 0v6a1 1 0 0 1-1 1z"
});

var SvgReload = function SvgReload(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: 62,
    height: 62,
    viewBox: "0 0 62 62",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgReload, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/reload.1555c212.svg";
export { ForwardRef as ReactComponent };